// PintaFlow First-Run Coach — small event bus + step definitions.
// Components dispatch `markCoachStep(id)` after a real user action; the
// CoachTour component listens and advances when the current step matches.

export const COACH_EVENT = "pintaflow:coach-step";

export const COACH_STEPS = [
  {
    id: "create-idea",
    eyebrow: "Step 01",
    title: "Capture your first",
    titleItalic: "idea.",
    body: "Type any topic and hit New idea — even a half-baked thought. The Vault catches everything.",
    route: "/dashboard",
    targetSelector: '[data-coach="new-idea"]',
    placement: "bottom",
    // hint that helps the user know what to do
    hint: "Click \"New idea\" to add one.",
  },
  {
    id: "generate-script",
    eyebrow: "Step 02",
    title: "Let the Co-pilot",
    titleItalic: "write it.",
    body: "Open the AI Co-pilot — hook, intro, body, CTA in under 10 seconds. This is where PintaFlow earns its keep.",
    route: "/dashboard",
    targetSelector: '[data-coach="ai-copilot"]',
    placement: "bottom",
    hint: "Open the AI Co-pilot and generate a script.",
  },
  {
    id: "move-pipeline",
    eyebrow: "Step 03",
    title: "Move an idea through the",
    titleItalic: "pipeline.",
    body: "Tap the small arrow on any card (or drag on desktop) to push it to the next stage. The motion itself is the ritual.",
    route: "/pipeline",
    targetSelector: '[data-coach="pipeline-board"]',
    placement: "top",
    hint: "Tap the → arrow on any card — or drag it (desktop).",
  },
  {
    id: "check-analytics",
    eyebrow: "Step 04",
    title: "See the",
    titleItalic: "mirror.",
    body: "Every publish, every view, every spike — laid out without anxiety. Numbers tell a story; PintaFlow keeps the page calm.",
    route: "/analytics",
    targetSelector: '[data-coach="analytics-root"]',
    placement: "top",
    hint: "Just landing here counts — Analytics is now open.",
    autoCompleteOnRoute: true,
  },
  {
    id: "set-goal",
    eyebrow: "Step 05",
    title: "Set the",
    titleItalic: "rhythm.",
    body: "One quiet weekly target. PintaFlow auto-tracks every publish against it. You don't have to.",
    route: "/goals",
    targetSelector: '[data-coach="goals-new"]',
    placement: "bottom",
    hint: "Tap \"New goal\" to set one.",
  },
];

export function markCoachStep(stepId) {
  try {
    window.dispatchEvent(new CustomEvent(COACH_EVENT, { detail: { step: stepId } }));
  } catch {
    /* noop */
  }
}

export const GUEST_COACH_KEY = "pintaflow:coach:guest";
